import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from 'components/common/FalconCardHeader';
import FailedRequest from 'components/requests-response/FailedRequest';
import SuccessRequest from 'components/requests-response/SuccessRequest';
import { useAuthenticatedUser } from 'hooks/useAuthenticatedUser';
import useNotification from 'hooks/useNotification';
import { useEffect, useRef, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import AgentsService from 'services/Agents.service';

const ChangePassword = ({ hasCard = true, btnClassName = '', ...props }) => {
  const form = useRef(null);
  const { authenticatedUser } = useAuthenticatedUser();
  const { showSuccessNotification, showErrorNotification } = useNotification();

  const [validated, setValidated] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [error, setError] = useState({});
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  useEffect(() => {
    // authenticatedUser já está disponível do provider
  }, []);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async e => {
    if (form.current.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
    } else {
      if (!authenticatedUser?.id) {
        showErrorNotification('Usuário não autenticado');
        return;
      }
      let request = await AgentsService.updatePassword(
        authenticatedUser.id,
        formData
      );
      if (request.ok) {
        showSuccessNotification('Senha alterada com sucesso');
        clearFields();
      } else {
        showErrorNotification(request.userMessage);
      }
    }
  };

  const clearFields = () => {
    setFormData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
  };

  const content = (
    <Form validated={validated} ref={form}>
      <Form.Group className="mb-3" controlId="currentPassword">
        <Form.Label>Senha atual</Form.Label>
        <Form.Control
          type="password"
          value={formData.currentPassword}
          name="currentPassword"
          onChange={handleChange}
        />
      </Form.Group>
      <Form.Group className="mb-3" controlId="newPassword">
        <Form.Label>Nova senha</Form.Label>
        <Form.Control
          type="password"
          value={formData.newPassword}
          name="newPassword"
          pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=\S+$).{8,}$"
          onChange={handleChange}
        />
        <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
        <Form.Control.Feedback type="invalid">
          A senha deve ter 8 caracteres, incluindo pelo menos uma letra
          maiúscula, um número e um caractere especial.
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3" controlId="confirmPassword">
        <Form.Label>Confirmar senha</Form.Label>
        <Form.Control
          type="password"
          value={formData.confirmPassword}
          name="confirmPassword"
          pattern="^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=\S+$).{8,}$"
          onChange={handleChange}
        />
        <Form.Control.Feedback>Muito bom!</Form.Control.Feedback>
        <Form.Control.Feedback type="invalid">
          A senha deve ter 8 caracteres, incluindo pelo menos uma letra
          maiúscula, um número e um caractere especial.
        </Form.Control.Feedback>
      </Form.Group>
      <Button className={btnClassName || 'w-100'} onClick={handleSubmit}>
        <FontAwesomeIcon icon={faSave} className="me-2" />
        Salvar
      </Button>
    </Form>
  );

  return (
    <>
      <SuccessRequest
        message="Senha alterada com sucesso!"
        showAlert={showAlert}
        setShowAlert={() => setShowAlert(false)}
      />
      <FailedRequest
        message={error.userMessage}
        showAlert={showAlertError}
        setShowAlert={() => setShowAlertError(false)}
      />
      {hasCard ? (
        <Card className="mb-3">
          <FalconCardHeader title="Alterar senha" />
          <Card.Body>{content}</Card.Body>
        </Card>
      ) : (
        content
      )}
    </>
  );
};

export default ChangePassword;
